import { Component, OnInit, Input, OnChanges, ChangeDetectorRef } from '@angular/core';
import { RestApiServices } from '../providers/rest.service';
import { Constant } from '../Constant'
import { CustomStorage } from "../providers/Custom-storage.service";
import { Router, NavigationStart } from '@angular/router';
import { LoaderComponent } from '../loader/loader.component';
import { Location } from '@angular/common';
// import { OrderdescriptionComponent } from '../orderdescription/orderdescription.component';
import { SharedServiceService } from '../shared/shared-service.service';
import { AfterViewChecked } from '@angular/core/src/metadata/lifecycle_hooks';
import { LanguageService } from '../providers/lang.service';
import { CartitemsService } from '../providers/cartitems.service';
import { environment } from '../../environments/environment';
// import { Ng2SearchPipeModule } from 'ng2-search-filter';
//import { OnlyNumber } from '../providers/keys';
import { ActivatedRoute } from '@angular/router';
@Component({
  moduleId: module.id,
  selector: 'orderlist',
  templateUrl: './orderlist.component.html',
  styleUrls: ['./orderlist.component.css']
})
export class OrderlistComponent implements OnInit {
  msg: string;
  errorData: any = {}
  operSessionDialog: boolean
  openOrdersDialog: boolean = false;
  private imageUrl = environment.imageUrl;
  errorMsg: string;session_msg: string = "";
  repeatorder: string = ""; placedon: string = ""; ordersummary: string = ""; order_total: string = "";
  sub_toal: string = ""; shipping_handling: string = ""; tax_city: string = ""; tax_state: string
  shippedon: string = "";shippinginfo: string = ""; lbl_ok: string = ""
  billinginfo: string = ""; orderedon: string= "";ordersearch: string="";months_txt: string="";
   getClass: boolean;last_txt: string="";all_statuses: string="";quantity_text: string="";ok_txt: string = "";
  winWidth: number;order_number: string=""; lbl_status: string="";result_notfound: string="";
  checkoutdata = [];lbl_uom : string = "";lbl_qty : string = "";item_text: string = ""; lbl_pack: string = "Pack Size";
  orderdata = [];all_open: string="";all_close: string="";
  customerdetailsData = [];
  subtotalvalue: any;
  selected_ship_num: string = 'PRIMARY';
  showloading: boolean = true;
  // gotChange:boolean;
  // getClass: boolean;
  statuses = []
  @Input() width: number;
  //  @Input() getclass: boolean
  // statuses = ["All Statuses", "open", "partially shipped" , "closed"]
  months = ["1", "3", "6"];
  selectedStatus = this.statuses[0];
  selectedTimeSpan = this.months[1];
  orderdataDetail :any={};
  ordernumber: any;
  ordernumberQuery: any;
  orderSingleData: any;
  constructor(private route: ActivatedRoute, private restApi: RestApiServices, private localStorage: CustomStorage,
    public router: Router, private location: Location,private localCart: CartitemsService,
    private sharedService: SharedServiceService, private langService: LanguageService, private cdRef: ChangeDetectorRef) {

      var orderNumber = route.snapshot.params['orderNumber'];
      if(orderNumber) {
        this.ordernumberQuery = orderNumber;
      }
      
  }

 
  ngOnInit() {
  
    this.langService.getJson().subscribe(data => {
      if (data) {
        this.setLabels();
        LoaderComponent.loadingV.next(true);
        this.restApi.getorderList(this.selectedTimeSpan).subscribe(data => {
          // console.log(data);
          if (data) {
            let my_data = JSON.parse(data._body);
            if (my_data.response.error_message === '' && my_data.response.orders_history.length > 0) {
              let mydata = my_data.response.orders_history;
              this.orderdata = mydata;
              this.getStatus()

              this.showloading = false;
              LoaderComponent.loadingV.next(false);
            }
            else if (my_data.response.orders_history.length === 0) {
              this.msg = my_data.response.error_message;
              // console.log("error msg is " + this.msg);
              this.showloading = false;
              LoaderComponent.loadingV.next(false);
              this.openOrdersDialog = !this.openOrdersDialog;
            }
            else {
              LoaderComponent.loadingV.next(false)
              this.errorData = my_data.response.error_message;
              // console.log("error data is " + this.errorData);
              this.operSessionDialog = !this.operSessionDialog;
            }
          }
        }, error => {
          // console.log(error);
          LoaderComponent.loadingV.next(false)
          //this.errorData = error.json().response
          this.errorMsg = error.json().response
          // console.log("error data is currently " + this.errorMsg);
          this.operSessionDialog = !this.operSessionDialog;
        })
        this.restApi.selectedOrderSource.subscribe(data => {
          if (this.orderdata.length > 0) {
            if (data) {
              this.orderdataDetail = data;
            }
          }
        })
        this.localStorage.getItem(Constant.KEY_CUSTOMER).subscribe(result => {
          this.customerdetailsData = result.response.data;
          // this.openOrder = this.customerdetailsData.open_order_info;   
        });
      }
    });

    // console.log(this);

  }
  closeSessionDialog(){
    // this.localStorage.emptyStorage();
    this.sharedService.removeAllData();
    this.router.navigate(['/login'])
  }
  openSessionCheck() {
    // this.localStorage.emptyStorage();
    this.sharedService.removeAllData();
    this.operSessionDialog = !this.operSessionDialog;
    this.router.navigate(['/login'])
  }
  closeOrderDialog() {
    this.router.navigate(['/dashboard/shop']);
  }

  getStatus() {
    this.orderSingleData = this.orderdata.filter(
      order => order.order_number === this.ordernumberQuery);

    
      //this.statuses = [];
    //this.statuses = this.statuses[0];
    this.selectedStatus = this.statuses[0];
    for (let i = 0; i < this.orderdata.length; i++) {
      if (!this.statuses.includes(this.orderdata[i].order_status)) {
        this.statuses.push(this.orderdata[i].order_status);
      }
      if(this.orderSingleData && this.orderSingleData.length != 0) {
        this.categorySelected(this.orderSingleData[0]);
      } else if (this.orderdata.length > 0 && this.width > 648) {
        this.categorySelected(this.orderdata[0]);
      }
    }
    
  }
  
  onChange(e) {
    if (e) {
     
      this.restApi.getorderList(e).subscribe(data => {
         let mdata = JSON.parse(data._body)
        this.orderdata = mdata.response.orders_history;
        this.getStatus()
      })
    }
  }

  categorySelected(orderdata) {
    if(this.ordernumberQuery) {
      this.location.replaceState("/dashboard/order");
    }
    // this.sharedService.sethideCategoriesflag(true);
    this.ordernumber = orderdata.order_number;
    this.restApi.changeSelectedorder(orderdata);
   // console.log("ordered data"+JSON.stringify(this.orderdata));

    if (this.width < 648) {
      this.getClass = !this.getClass; 

    }

  }


  setLabels() {
    this.langService.getLangLabelValue("LblRepeatThisOrder").then(result => {
      this.repeatorder = result;
    });
    this.langService.getLangLabelValue("LblPlacedOn").then(result => {
      this.placedon = result;
    });
    this.langService.getLangLabelValue("LblOrderSummary").then(result => {
      this.ordersummary = result;
    });
    this.langService.getLangLabelValue("LblOrder").then(result => {
      this.ordersearch = result;
    });
    this.langService.getLangLabelValue("LblSubTotal").then(res => {
      this.sub_toal = res
    });
    this.langService.getLangLabelValue("LblShipping_Handling").then(res => {
      this.shipping_handling = res
    });
    this.langService.getLangLabelValue("LblCityTax").then(res => {
      this.tax_city = res
    });
    this.langService.getLangLabelValue("LblStateTax").then(res => {
      this.tax_state = res
    });
    this.langService.getLangLabelValue("LblOrderTotal").then(res => {
      this.order_total = res
    });
    this.langService.getLangLabelValue("LblShippedOn").then(res => {
      this.shippedon = res
    });
    this.langService.getLangLabelValue("LblShippingInformation").then(res => {
      this.shippinginfo = res
    });
    this.langService.getLangLabelValue("LblBillingInformation").then(res => {
      this.billinginfo = res
    });
    this.langService.getLangLabelValue("LblOrderedOn").then(res => {
      this.orderedon = res
    });
    this.langService.getLangLabelValue("LblMonth").then(res => {
      this.months_txt = res
    });
    this.langService.getLangLabelValue("LblLast").then(res => {
      this.last_txt = res
      
    });
    this.langService.getLangLabelValue("Lblok").then(res => {
      this.lbl_ok = res
    });
    this.langService.getLangLabelValue("LblAllStatuses").then(result => {
     this.all_statuses = result;
     this.statuses.push(this.all_statuses);
      this.localCart.orderstatuses[this.all_statuses] = 0;
    });
    // this.langService.getLangLabelValue("LblOpen").then(result => {
    //   this.all_open = result;
    //   this.statuses.push(this.all_open);
    //    this.localCart.orderstatuses[this.all_open] = 1;
    //  });
    //  this.langService.getLangLabelValue("LblClose").then(result => {
    //   this.all_close = result;
    //   this.statuses.push(this.all_close);
    //    this.localCart.orderstatuses[this.all_close] = 2;
    //  });
    this.langService.getLangLabelValue("LblQuantity").then(res => {
      this.quantity_text = res
    });
    this.langService.getLangLabelValue("LblOrderNumber").then(res => {
      this.order_number = res
    });
    this.langService.getLangLabelValue("LblStatus").then(res => {
      this.lbl_status = res
      
    });
    this.langService.getLangLabelValue("200_no_data_found").then(res => {
      this.result_notfound = res
      
    });
    this.langService.getLangLabelValue("LblItem").then(res => {
      this.item_text = res
    });
    this.langService.getLangLabelValue("LblItemUOM").then(result => {
      this.lbl_uom = result;  
    });
    this.langService.getLangLabelValue("LblUOMQty").then(result => {
      this.lbl_qty = result;  
    });
    this.langService.getLangLabelValue("200_session_expired").then(result => {
      this.session_msg = result;  
    });
   
  }
  //  backButton(){
  //    this.location.back
  //  }
 
    repeatorders(){
      
      this.router.navigate(['/checkout',{ 'repeatOrder' : true, 'orderNo' : this.orderdataDetail.order_number}]);
       
      }

  wasClicked() {
    this.getClass = !this.getClass;
  }
  getstatusmsg(statusNo) {
   
        if (statusNo == "1") {
          alert("sd"+this.all_open)
          return this.all_open;
        }
        if (statusNo == "2") {
          return this.all_close;
    
        }
        
        return "";
      }
}



// WEBPACK FOOTER //
// ./src/app/orderlist/orderlist.component.ts